import { useEffect, useRef } from 'react'
import { ValidationSchema } from '../../../@types/validation-types'
import { SaveType } from '../../../@types/types'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { InitState } from '../../../redux/reducers/root/initialState'
import { doAutoSaveDecider } from '../../../redux/thunks/wizard/doAutoSaveDecider'

export function useRetryAutosaveAfterSaveCompletion(validationSchema: ValidationSchema) {
  const dispatch = useAppDispatch()
  const { changed, save } = useAppSelector((state: InitState) => state.insertionFeature)
  const previousSaveStatus = useRef(save)

  useEffect(() => {
    const hasSaveJustFinished = previousSaveStatus.current === SaveType.SAVING && save === SaveType.SAVED

    if (hasSaveJustFinished && changed) {
      dispatch(doAutoSaveDecider(validationSchema))
    }

    previousSaveStatus.current = save
  }, [changed, dispatch, save, validationSchema])
}
